'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeCancelHoldEvent = composeCancelHoldEvent;
exports.composePlaceHoldEvent = composePlaceHoldEvent;
exports.composePauseHoldEvent = composePauseHoldEvent;
exports.composeResumeHoldEvent = composeResumeHoldEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

var _shelvesEventComposer = require('./shelvesEventComposer');

var _getLabelForProvider = require('./getLabelForProvider');

var _getLabelForProvider2 = _interopRequireDefault(_getLabelForProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;


function composeHoldEvent(_ref) {
  var event = _ref.event,
      gtmAction = _ref.gtmAction,
      gtmValue = _ref.gtmValue,
      gtmLabel = _ref.gtmLabel,
      metadataIds = _ref.metadataIds,
      payload = _objectWithoutProperties(_ref, ['event', 'gtmAction', 'gtmValue', 'gtmLabel', 'metadataIds']);

  return (0, _compose.composeEvent)(event, _extends({
    gtmAction: gtmAction,
    gtmValue: gtmValue,
    gtmCategory: CATEGORIES.HOLDS,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM,
    gtmLabel: gtmLabel,
    metadataIds: metadataIds
  }, payload));
}

function composeCancelHoldEvent(_ref2) {
  var holdCount = _ref2.holdCount,
      metadataIds = _ref2.metadataIds,
      shelfState = _ref2.shelfState,
      provider = _ref2.provider;

  var events = [];
  if (shelfState && shelfState.toAdd) {
    events.push((0, _shelvesEventComposer.composeShelfEvent)(EVENTS.ADD_TO_SHELF, metadataIds, shelfState.name, ACTIONS.ADD_CONTENT));
  }

  events.push(composeHoldEvent({
    event: EVENTS.CANCEL_HOLD,
    gtmAction: ACTIONS.CANCEL_HOLD,
    gtmValue: holdCount,
    gtmLabel: (0, _getLabelForProvider2.default)(provider),
    metadataIds: metadataIds
  }));

  return (0, _compose.composeAnalytics)(events);
}

function composePlaceHoldEvent(_ref3) {
  var metadataIds = _ref3.metadataIds,
      provider = _ref3.provider;

  return (0, _compose.composeAnalytics)([composeHoldEvent({
    event: EVENTS.PLACE_HOLD,
    gtmAction: ACTIONS.PLACE,
    gtmValue: 1,
    metadataIds: metadataIds,
    gtmLabel: (0, _getLabelForProvider2.default)(provider)
  })]);
}

function composePauseHoldEvent(_ref4) {
  var holdCount = _ref4.holdCount,
      metadataIds = _ref4.metadataIds;

  return (0, _compose.composeAnalytics)([composeHoldEvent({
    event: EVENTS.PAUSE_HOLD,
    gtmAction: ACTIONS.PAUSE_HOLD,
    gtmValue: holdCount,
    metadataIds: metadataIds
  })]);
}

function composeResumeHoldEvent(_ref5) {
  var holdCount = _ref5.holdCount,
      metadataIds = _ref5.metadataIds;

  return (0, _compose.composeAnalytics)([composeHoldEvent({
    event: EVENTS.RESUME_HOLD,
    gtmValue: holdCount,
    metadataIds: metadataIds,
    gtmAction: ACTIONS.RESUME_HOLD
  })]);
}

exports.default = {
  composePlaceHoldEvent: composePlaceHoldEvent,
  composeCancelHoldEvent: composeCancelHoldEvent,
  composePauseHoldEvent: composePauseHoldEvent,
  composeResumeHoldEvent: composeResumeHoldEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/holdsEventComposer.js
// module id = 581
// module chunks = 0 2 4 5 6 8 9 10 11